import { render } from "./p-address.vue?vue&type=template&id=06113437"
import script from "./p-address.vue?vue&type=script&lang=js"
export * from "./p-address.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/p-address.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06113437"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06113437', __exports__)) {
    api.reload('06113437', __exports__)
  }
  
  module.hot.accept("./p-address.vue?vue&type=template&id=06113437", () => {
    api.rerender('06113437', render)
  })

}


export default __exports__